<div class="auth-container">
    <!-- Show spinner and "Authenticating..." message while authentication is in progress -->
    <ng-container *ngIf="!isAuthenticated; else redirectTemplate">
      <div class="spinner"></div>
      <p>Authenticating...</p>
    </ng-container>
  
    <!-- When authentication is done, show the appropriate redirect message with countdown -->
    <ng-template #redirectTemplate>
      <ng-container *ngIf="invalidCredentials; else validTemplate">
        <p>
          Invalid credentials. Redirecting to login page in
          {{ countDown }} second{{ countDown === 1 ? '' : 's' }}...
        </p>
      </ng-container>
      <ng-template #validTemplate>
        <p>
          Redirecting you in {{ countDown }} second{{ countDown === 1 ? '' : 's' }}...
        </p>
      </ng-template>
    </ng-template>
  </div>
  